import * as React from "react";

const SvgShortcut = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9 21H10.0004C10.4859 20.3536 10.8184 19.5857 10.9441 18.75H21.9V7.5H12.6337L10.5338 5.25H5.1V13.0808C4.32243 13.2221 3.60755 13.5433 3 13.9996V5.25C3 4.63125 3.20563 4.10156 3.61687 3.66094C4.02813 3.22031 4.5225 3 5.1 3H11.4L13.5 5.25H21.9C22.4775 5.25 22.9719 5.47031 23.3831 5.91094C23.7944 6.35156 24 6.88125 24 7.5V18.75C24 19.3687 23.7944 19.8984 23.3831 20.3391C22.9719 20.7797 22.4775 21 21.9 21Z"
      fill="#F0F0F0"
    />
    <circle cx="6" cy="18" r="4" fill="#F0F0F0" />
    <mask
      id="mask0_10129_22975"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="15"
      width="7"
      height="7"
    >
      <rect x="2" y="15.6" width="6.4" height="6.4" fill="#131313" />
    </mask>
    <g mask="url(#mask0_10129_22975)">
      <path
        d="M4.29759 20.4L3.86682 19.9405L6.82067 16.7897H4.17451V16.1333H7.86682V20.0718H7.25144V17.2492L4.29759 20.4Z"
        fill="#181818"
      />
    </g>
  </svg>
);
export default SvgShortcut;
